import { Ds, Feedback } from "@accurx/design";
import styled from "styled-components";

export const StyledSelfbookForm = styled.div`
    background-color: var(--ds-color-white);
    padding: 0 1rem 1rem 1rem;
    height: 100%;
    overflow-y: auto;
    scrollbar-gutter: stable;
`;

export const StyledSelfbookModal = styled.div`
    background-color: var(--ds-color-white);
    height: 100vh;
    overflow-y: hidden;
`;

export const StyledFeedback = styled(Feedback)`
    padding: 1rem 0.5rem;
`;

export const SpinnerPositioning = styled(Ds.Flex)`
    height: 100%;
    justify-content: center;
    align-items: center;
`;

export const StyledFooter = styled.div<{
    marginBottom?: number | string;
}>`
    bottom: 0;
    width: 100%;
    background-color: var(--ds-color-white);
    border-top: 1px solid var(--ds-color-silver);
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    // added margin because a bottom margin is added in wpf
    // to avoid issue where webview corners are not rounded
    margin-bottom: ${(props) => props.marginBottom ?? 0};
`;

export const StyledInnerWrapper = styled(Ds.Flex).attrs({
    flexDirection: "column",
})`
    height: 100%;
`;
export const StyledMiddleWrapper = styled.div`
    position: relative;
    height: 100%;
`;

export const StyledOuterWrapper = styled.div`
    overflow-y: hidden;
    // dvh is same as vh with dynamic changes with respect to change in ui such as components behind feauture flags
    height: 100dvh;
`;

export const TelephoneDetailsWrapper = styled.div`
    margin: 1.5rem 1rem;
`;

export const ErrorPositioningWrapper = styled.span`
    margin-top: 0.25rem;
`;

export const SubTitlePositioning = styled.div`
    margin-left: o.25rem;
    margin-top: 0.125;
`;

export const StyledBoxSeparator = styled.div`
    border-bottom: 1px solid var(--ds-color-silver);
    margin-bottom: 1.5rem;
`;

export const TempFontWrapper = styled.div`
    * {
        font-size: 16px;
    }
`;
